<template>
    <div>
        <!--        <div class="advanced-search-location"  style="right: 0">-->
        <!--            <el-button type="info" plain size="mini" @click="backToMain()">-->
        <!--                <i class="fa fa-backward">-->
        <!--                </i> 返回-->
        <!--            </el-button>-->
        <!--        </div>-->
        <el-tabs v-model="activeTabName" @tab-click="jumpToList">
            <el-tab-pane label="列表" name="list">
            </el-tab-pane>
            <el-tab-pane label="详情" name="detail">
            </el-tab-pane>
        </el-tabs>
        <el-form label-position="right" :model="flow" ref="flow" :validate-on-rule-change="false" label-width="120px">
            <el-row class="bottom20">
                <el-row class="column-name" justify="start">
                    <span>基本信息</span>
                    <div class="navbar-right">
                        <el-button v-if="showExport" @click="exportPDF" size="mini">导出PDF</el-button>
                        <!--                        <a @click="exportPDF" href="javascript:void(0)"-->
                        <!--                           style="color: #FD8944;text-decoration: none;font-weight: 700">导出PDF</a>-->
                        <!--                        <a href="http://www.baidu.com" style="color: #FD8944;text-decoration: none;font-weight: 700">导出EXCEL</a>-->
                    </div>
                </el-row>
                <el-row>
                    <el-row>
                        <el-col :xs="24" :sm="24" :md="12" :lg="12" v-show="this.showContractName"><!--v-show='false'-->
                            <el-form-item label="合同名称" prop="reason">
                                <el-input v-model="contractName" :disabled="true" size="small">

                                </el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="24" :md="12" :lg="12">
                            <el-form-item label="客户名称" prop="reason">
                                <el-input v-model="customerName" :disabled="true" size="small">

                                </el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :xs="24" :sm="24" :md="12" :lg="12">
                            <el-form-item :label="billingCycleText" prop="reason">
                                <el-input v-model="billingCycle" :disabled="true" size="small">

                                </el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="24" :md="12" :lg="12">
                            <el-form-item label="系统金额(元)" prop="reason">
                                <el-input v-model="hisAmount" :disabled="true" size="small">

                                </el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :xs="24" :sm="24" :md="12" :lg="12">
                            <el-form-item label="要求到账日期" prop="reason" v-if="this.showRequiredDate">
                                <el-input v-model="requiredDate" :disabled="true" size="small">
                                </el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="24" :md="12" :lg="12">
                            <el-form-item label="实际到账日期" prop="reason" v-if="this.showFeeDate">
                                <el-input v-model="feeDate" :disabled="true" size="small">

                                </el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-row>
                <div v-if="normalCost!==null && normalCost!==''">
                    <el-row class="column-name" justify="start">
                        <span>计费信息</span>
                    </el-row>
                    <div v-html="normalCost">
                    </div>
                </div>
                <div v-if="specialCost!==null && specialCost!==''">
                    <el-row class="column-name" justify="start">
                        <span>特殊成本</span>
                    </el-row>
                    <div v-html="specialCost">
                    </div>
                </div>
                <el-row class="column-name" justify="start">
                    <span>流转信息</span>
                </el-row>
                <el-collapse>
                    <el-collapse-item style="margin-left: 1%;" v-for="(item,index) in activeFlows" :key="index">
                        <template slot="title">
                            <!--                            <div style="font-weight: 700">-->
                            <div>
                                <i class="el-icon-circle-check">
                                    {{item.operate}}
                                </i>
                                &#12288;&#12288;&#12288;
                                <i class="el-icon-user-solid">
                                    {{item.userName}}
                                </i>
                                &#12288;&#12288;&#12288;
                                <i class="el-icon-date">
                                    {{item.ts}}&nbsp
                                </i>
                                <!--                                <i class="header-icon el-icon-info" v-if="item.attach!==null && item.url !==null"></i>-->
                                <!--                                <i class="header-icon el-icon-info" style="color: red"-->
                                <!--                                   v-if="item.attach!==null && item.url===null"></i>-->
                            </div>
                        </template>
                        <div v-if="item.time">
                            <div>
                                {{item.operate}}日期：{{item.time}}
                            </div>
                            <br/>
                        </div>
                        <div v-if="item.files!==null && item.files.length>0">
                            附件:
                            <p v-for="(file,fileIndex) in item.files" :key="fileIndex">
                                {{file.fileName}}&nbsp;&nbsp;
                                <a href="javascript:void(0)" v-if="file.url !==null" @click="download(file.url,file.fileName)">下载</a>
                                <span style="color: red;font-weight: 700" v-else="file.url !==null">文件已丢失</span>
                            </p>
                        </div>
                        <br/>
                        <div v-html="item.memo">
                            备注:
                            <template v-if="item.memo!=null && item.memo !== undefined">{{item.memo}}</template>
                            <template v-else>无</template>
                        </div>
                    </el-collapse-item>
                </el-collapse>
                <el-row class="column-name" justify="start" v-show="this.customerBillDetail.type==='edit' && this.flow.visible">
                    <span>流转变更</span>
                </el-row>
                <el-row style="margin-left: 1%">
                    <div v-if="this.flow.visible">
                        <!--账单变更及账单确认开始-->
                        <el-form-item prop="confirmBillDate" label="账单确认日期*" v-if="formShowChangeOrConfirmBill()">
                            <el-date-picker v-model="flow.confirmBillDate"
                                            style="width: 160px"
                                            value-format="yyyy-MM-dd"
                                            type="date"
                                            placeholder="选择日期"
                                            size="mini"
                            >
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item prop="requiredDate" label="要求到账日期*" v-show="form.confirmBill">
                            <el-date-picker v-model="flow.requiredDate"
                                            style="width: 160px"
                                            value-format="yyyy-MM-dd"
                                            type="date"
                                            placeholder="选择日期"
                                            size="mini"
                            >
                            </el-date-picker>
                        </el-form-item>
                        <!--账单变更及账单确认结束-->
                        <!--到账确认、变更到账日期开始-->
                        <el-form-item label="操作*" prop="op" v-if="formShowInvoiceOrArriveBill()">
                            <el-select @change="isShowInvoiceDate" v-model="flow.op" placeholder="请选择" size="mini">
                                <el-option label="确认" :value=this.customerBillDetail.op></el-option>
                                <el-option label="撤销" value=-1></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="开票日期*" prop="invoiceDate" v-show="form.confirmInvoice && showInvoiceDate">
                            <el-date-picker v-model="flow.invoiceDate"
                                            style="width: 160px"
                                            value-format="yyyy-MM-dd"
                                            type="date"
                                            placeholder="选择日期"
                                            size="mini"
                            >
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="实际到账日期*" prop="feeDate" v-show="form.confirmArrive">
                            <el-date-picker v-model="flow.feeDate"
                                            style="width: 160px"
                                            value-format="yyyy-MM-dd"
                                            type="date"
                                            placeholder="选择日期"
                                            size="mini"
                            >
                            </el-date-picker>
                        </el-form-item>
                        <!--到账确认、变更到账日期结束-->
                        <el-form-item label="附件" prop="fileList" v-show="this.customerBillDetail.type==='edit'">
                            <el-upload
                                    ref='upload'
                                    class="upload-demo"
                                    :action="''"
                                    :before-upload="beforeAvatarUpload"
                                    :before-remove="beforeRemove"
                                    :http-request="addFile"
                                    :on-remove="removeFile"
                                    :on-exceed="handleExceed"
                                    :file-list="flow.fileList"
                                    multiple>
                                <el-button size="small" type="primary">添加附件</el-button>
                            </el-upload>
                        </el-form-item>
                        <el-form-item label="备注" prop="memo" v-show="this.customerBillDetail.type==='edit'">
                            <el-input type="textarea" v-model="flow.memo" maxlength="250" show-word-limit></el-input>
                        </el-form-item>
                    </div>
                    <el-button size="mini" icon="el-icon-check" @click="prepareNextFlow" :disabled="flow.disabled"
                               v-show="this.customerBillDetail.type==='edit' && this.flow.visible">提交
                    </el-button>
                    <el-button size="mini" icon="el-icon-back" @click="backToMain" :style="buttomBackStyle">返回</el-button>
                    <label v-model="errMsg" style="color: red">&nbsp;&nbsp;{{errMsg}}</label>
                </el-row>
            </el-row>
        </el-form>
    </div>
</template>

<script>
    import Emitter from 'element-ui/src/mixins/emitter'
    import AttachmentServer from '@/api/attachment'
    import {
        nextId,
        nextFlow,
        selectBillDetailByBillId,
        selectBillDetailNewHisByBillId,
        downloadFile
    } from '@/api/billing'
    import {exportPDFByBillId, getBillingAthubConfig} from "../../../../../api/billing";

    export default {
        name: 'billcustomerdetail',
        mixins: [Emitter],
        components: {},
        data() {
            return {
                buttomBackStyle:{},
                activeTabName: 'detail',
                requiredDate: null,  //要求到账日期
                activeFlows: [],
                contractName: null,
                customerName: null,
                hisAmount: null, //系统金额
                feeDate: null,   //实际日期
                billingCycle: null,  //计费周期
                billingCycleText: null, //计费周期文字
                showInvoiceDate: true, //是否显示开票日期
                showExport:false,   //是否显示导出PDF
                showContractName: false, //是否显示合同名称
                showRequiredDate:true, //是否显示要求到账日期
                showFeeDate:true,  //是否显示实际到账日期
                loading: true,
                form: {
                    flow: true,
                    changeBill: false,
                    confirmBill: false,
                    confirmInvoice: false,
                    confirmArrive: false
                },
                flow: {
                    visible:true,
                    feeDate: null,   //流程:实际到账日期
                    confirmBillDate: null,   //流程:账单确认日期
                    requiredDate: null,  //流程:要求到账日期
                    invoiceDate: null,   //流程:开票日期
                    memo: null,  //流程:备注信息
                    op: 1,    //流程:开票、到账、变更到账日期时的确认或取消
                    time: null,  //流程提交的实际到账日期、开票日期、账单确认日期
                    uploadFile: '',
                    isAllow2Upload: true,
                    fileList: [],
                    nextFlowId: null,    //本次流程ID
                    docLinksId: [], //上传成功后返回的docIDs
                    disabled: false
                },
                normalCost: null,   //普通计费信息
                specialCost : null, //特殊计费信息
                customerBillDetail: {},
                errMsg:null
            };
        },
        watch: {
            operation: {
                handler() {
                    this.$emit('operation-change', this.operation);
                }
            },
        },
        computed: {},
        created() {
            console.log("当前deptType:"+this.$route.params.deptType);
            if (this.$route.params === undefined || JSON.stringify(this.$route.params)==='{}'){
                //生成账单列表搜索条件置空
                localStorage.removeItem('billing:contract:bill:customer:generator');
                this.$router.push({
                    name: 'billcustomerlist',
                });
            } else{
                this.customerBillDetail = this.$route.params.customerBillDetail;
            }
            if (this.customerBillDetail.title==='khjfyb'){
                this.form.confirmArrive=false;
                this.showFeeDate=false;
                this.showRequiredDate=false;
                this.billingCycleText="月份";
                this.showExport=false;
                this.billingCycle=this.customerBillDetail.month;
            }else{
                this.billingCycleText="计费周期";
                this.showExport=true;
            }
            // console.log("customerBillDetail = > "+JSON.stringify(this.customerBillDetail));
            this.flow.op=this.customerBillDetail.op;
            this.loadCustomerBillDetail(this.customerBillDetail.billId,this.customerBillDetail.op);
            if (this.customerBillDetail.type!=='edit'){
                this.buttomBackStyle={
                    marginTop:'20px',
                    marginLeft:'0px'
                };
            }else{
                this.buttomBackStyle={}
            }
        },
        mounted() {

        },
        methods: {
            //是否显示开票日期
            isShowInvoiceDate(value){
                this.showInvoiceDate = value === 1;
            },
            arraySpanMethod({ row, column, rowIndex, columnIndex }) {

            },
            jumpToList(){
                if (this.activeTabName === 'list') {
                    this.backToMain();
                }
            },
            /**
             *  異步:獲取賬單詳情
             *  @param billId 賬單id
             *  @param isNew 是否加载最新的his信息
             */
            async getBillDetail(billId,isNew) {
                try {
                    let res=null;
                    if (isNew) {
                        res = await selectBillDetailNewHisByBillId(billId);
                    }else{
                        res = await selectBillDetailByBillId(billId);
                    }
                    let result = res.data.data;
                    this.feeDate = result.feeDate === null ? '无' : result.feeDate;
                    this.hisAmount = result.hisAmount === null ? '无' : result.hisAmount;
                    this.requiredDate = result.requiredDate === null ? '无' : result.requiredDate;
                    this.contractName = result.contractName;
                    this.customerName = result.customerName;
                    this.activeFlows = result.flows;
                    this.showContractName = result.showContractName;
                    this.normalCost=result.normalCost;
                    this.specialCost=result.specialCost;
                    if (this.customerBillDetail.month === undefined){
                        this.billingCycle = result.billingCycle;
                    }
                } catch (e) {
                    console.log(e);
                }
            },
            /**
             * 加載客戶賬單詳情數據
             * @param billId 賬單id
             * @param op 操作類型
             */
            loadCustomerBillDetail(billId,op){
                let isNew=false;
                if (op === 0) { //账单确认
                    // this.$refs['flow'].resetFields();
                    this.getNextFlowId();
                    this.form.flow = true;
                    this.form.confirmBill = true;
                    this.form.confirmInvoice = false;
                    this.form.confirmArrive = false;
                    this.form.changeBill = false
                }
                if (op === 1) { //开票确认
                    // this.$refs['flow'].resetFields();
                    this.getNextFlowId();
                    this.form.flow = true;
                    this.form.confirmBill = false;
                    this.form.confirmInvoice = true;
                    this.form.confirmArrive = false;
                    this.form.changeBill = false
                }
                if (op === 2) { //到账确认
                    // this.$refs['flow'].resetFields();
                    this.getNextFlowId();
                    this.form.flow = true;
                    this.form.confirmBill = false;
                    this.form.confirmInvoice = false;
                    this.form.confirmArrive = true;
                    this.form.changeBill = false
                }
                if (op === 3) { //变更账单
                    // this.$refs['flow'].resetFields();
                    this.getNextFlowId();
                    this.form.flow = true;
                    this.form.confirmBill = false;
                    this.form.confirmInvoice = false;
                    this.form.confirmArrive = false;
                    this.form.changeBill = true;
                    isNew=true;
                } else if (op === undefined) {
                    if (this.customerBillDetail.parent !== 'billcustomerlist'){
                        isNew=true;
                    }
                    this.form.flow = false;
                }
                this.getBillDetail(billId,isNew);
            },

            /**
             * 根據上一列表name返回到對應列表
             */
            backToMain() {
                if (this.customerBillDetail.parent === 'billcustomerlist') {
                    this.$router.push({
                        name: 'billcustomerlist',
                        query: {deptType: this.customerBillDetail.deptType}
                    });
                } else {
                    this.$router.push({
                        name: 'billcustomergeneratorlist',
                        query:{
                            deptType:this.$route.params.deptType
                        }
                    });
                }
            },
            download(url,filename) {
                AttachmentServer.attachment.downloadFile(url, filename);
            },
            //get FlowId
            async getNextFlowId() {
                try {
                    this.flow.disabled = false;
                    let result = await nextId();
                    this.flow.nextFlowId = result.data.data;
                    console.log("flow_id", this.flow.nextFlowId)
                } catch (e) {
                    console.log(e);
                }
            },
            //file:
            removeFile(file) {
                let files = this.flow.fileList;
                let index = -1;
                for (let i = 0, len = files.length; i < len; i++) {
                    if (file.uid === files[i].uid) {
                        index = i;
                        break;
                    }
                }
                if (index > -1) {
                    this.flow.fileList.splice(index, 1);
                }
            },

            beforeRemove(file, fileList) {
                console.log("beforeRemove:" + file, fileList);
                if (this.flow.isAllow2Upload) {
                    return this.$confirm(`确定移除 ${file.name}？`);
                }
            },

            handleExceed(files, fileList) {
                console.log("handleExceed:" + file, fileList);
                // this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
                this.$message.warning(`当前限制选择1个文件，请删除选择的文件再添加`);
            },
            addFile(params) {
                this.flow.fileList.push(params.file);
            },
            beforeAvatarUpload(file) {
                const isLt2M = file.size / 1024 / 1024 < 5;
                if (!isLt2M) {
                    this.$message.error('上传附件大小不能超过 5MB!');
                    this.flow.isAllow2Upload = false;
                }
                return isLt2M;
            },

            //流程：变更账单或确认账单时控件可见
            formShowChangeOrConfirmBill() {
                return this.form.confirmBill || this.form.changeBill;
            },
            //流程:开票确认时控件可见
            formShowInvoiceOrArriveBill() {
                return this.form.confirmInvoice;
            },
            async prepareNextFlow() {
                this.flow.disabled=true;
                let fileNames=[];
                try {
                    for(let i=0;i<this.flow.fileList.length;i++){
                        fileNames=fileNames.concat(this.flow.fileList[i].name);
                        let params = {
                            file: this.flow.fileList[i],
                            ownerTable: 'billing_contract_bill_flow',
                            docType: 'BILLINGFLOW',
                            ownerId: this.flow.nextFlowId,
                        };
                        let result = await AttachmentServer.attachment.upload(params);
                        let data = eval('result');
                        if (data.code===undefined){
                            if (data[0].URL !== undefined && data[0].URL != null && data[0].URL !== '') {
                                this.flow.docLinksId = this.flow.docLinksId.concat(data[0].docLinksId);
                            }
                        }else{
                            await this.reverseFile();
                            this.$message.warning("文件上传失败,请刷新页面重试.");
                            this.flow.disabled=false;
                            // this.errMsg="文件上传失败,请刷新页面后重试.";
                        }
                    }
                    await this.startNextFlow(fileNames);
                }catch (e) {
                    await this.reverseFile();
                    this.$message.warning("文件上传失败,请刷新页面重试.");
                    this.flow.disabled=false;
                    // this.errMsg="文件上传失败,请刷新页面后重试.";
                }
            },
            //下一流程
            async startNextFlow(fileNames) {
                let op = this.flow.op;
                if (op === null) {
                    // op = this.customerBillDetail.op;
                    this.$message.error("请选择操作!");
                    this.flow.disabled=false;
                }else {
                    let time = null;
                    switch (op) {
                        case 0:
                        case 3:
                            time = this.flow.confirmBillDate;
                            break;
                        case 1:
                            time = this.flow.invoiceDate;
                            break;
                        case 2:
                            time = this.flow.feeDate;
                            break;
                        default:
                            time = null;
                            break;
                    }
                    let params = {
                        billId: this.customerBillDetail.billId,
                        op: op,
                        memo: this.flow.memo,
                        requiredDate: this.flow.requiredDate, //要求到账日期
                        time: time,
                        attach: JSON.stringify(fileNames),
                        id: this.flow.nextFlowId
                    };
                    try {
                        this.flow.disabled = true;
                        let result = await nextFlow(params);
                        if (result.data.success) {
                            this.$message.success(result.data.data);
                            //流程变更窗口不可见 提交按钮不可见 同时刷新流转信息
                            this.flow.visible = false;
                            this.loadCustomerBillDetail(this.customerBillDetail.billId, this.customerBillDetail.op);
                            this.buttomBackStyle = {
                                marginTop: '20px',
                                marginLeft: '0px'
                            };
                        } else {
                            await this.reverseFile();
                            this.$message.error(result.data.responseMessage);
                            this.flow.disabled = false;
                        }
                    } catch (e) {
                        await this.reverseFile();
                        console.log(e);
                    }
                }
            },

            /**
             * 删除本次上传的附件
             */
            async reverseFile() {
                for (let i=0;i<this.flow.docLinksId.length;i++){
                    let result = await AttachmentServer.attachment.delete(this.flow.docLinksId[i], getBillingAthubConfig());
                    console.log('删除结果:' + JSON.stringify(result));
                }
            },

            /**
             * 導出PDF
             */
            exportPDF() {
                exportPDFByBillId(this.customerBillDetail.billId);
            }
        },
    }
</script>

<style scoped>
    .table{
        border: 2px;
    }
    /deep/.el-table .cell {
        white-space: pre-line!important;
    }
</style>
